import { authType } from '../actions/type';
import * as StorageService from '../services/storage.service';

function getInitialState() {
  const user = StorageService.getObject('authUser');

  const initialState = user
    ? { isLoggedIn: true, user }
    : { isLoggedIn: false, user: null };

  return initialState;
}

function authenticate(state = null, action) {
  if (state == null) {
    state = getInitialState();
  }

  const { type, payload } = action;
  switch (type) {
    case authType.SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case authType.FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case authType.LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    default:
      return state;
  }
}

export default authenticate;
